jQuery(document).ready(function($) {
  $(".mega-menu").hover(function(e) {
    console.log("hover");
    $(this).find("summary").attr("aria-expanded", true);
    $(this).attr("open", true);
  }, function(e) {
    $(this).find("summary").attr("aria-expanded", false);
    $(this).removeAttr("open");
  });

  $("summary.list-menu__item[data-href]").click(function(e) {
    var url = $(this).attr("data-href");

    if(url && url != '') {
      window.location.href = url;
    }
  });

  $(".footer-block__heading").click(function(e) {
    $(this).toggleClass("opened");
    $(this).parent().find(".footer-block__details-content").toggle();
  });


  // toggle open 
   $(document).on("click", ".itg_toggle", function() {
        $(this).toggleClass('active');
        $(this).find('ul li').slideToggle();
  });

// first active option 
  $('.itg_toggle').each(function() {
    var dataName = $(this).attr('data-name');
    var activeValue = $(this).find('li.active').data('value');
    $('.product-form__input[data-name="'+ dataName +'"] input[data-title="'+ activeValue +'"]').trigger('click');
  });


  // item click value set 
   $(document).on("click", ".itg_toggle li", function() {
    $(this).addClass('active').siblings().removeClass('active'); 
    var dataName = $(this).closest('.itg_toggle').attr('data-name');
    var activeValue = $(this).data('value');
    var active_text= $(this).html();
     $(this).closest('.itg_toggle').find('.main_item').html(active_text);

      setTimeout(function() {
       var getPrice = $('.price__container .main_price').text();
    $('.product-form__buttons span.cart_btn_price').html(getPrice);
    }, 1500);
     
     $('.product-form__input[data-name="'+ dataName +'"] input[data-title="'+ activeValue +'"]').trigger('click');
     
     });



    
    $(document).on("click", ".product-form__input input[type=radio]+label", function() {
   
    setTimeout(function() {
       var getPrice = $('.price__container .main_price').text();
    $('.product-form__buttons span.cart_btn_price').html(getPrice);
    }, 1500);
    });


  // popup js
   $(document).on("click", "span#size_chart", function() {
     $('.size_chart_popup').show();
     $('body').addClass('popup_on');
      });
    $(document).on("click", ".popup_close", function() {
       $('body').removeClass('popup_on');
     $('.size_chart_popup').hide();
      });
  $(document).on("click", "body.popup_on", function() {
     $('.size_chart_popup').hide();
    $(this).removeClass('popup_on');
      });

   $(document).on("click", ".en_logo", function() {
      $('.store_toggle').toggle();
     });

   $(document).on("click", ".size_order_list img", function() {
    $(this).toggleClass('img_zoom');
     });


  
  });